"use client";
import React from "react";
import { usePathname } from "next/navigation";
import AppErrorBoundary from "@/components/common/AppErrorBoundary";

/**
 * Wraps the whole client tree under the root layout. Catches render-time errors
 * in any descendant; resetKey follows the URL so a route change clears the fallback.
 */
export default function AppRootErrorBoundary({ children }) {
  const pathname = usePathname();

  return (
    <AppErrorBoundary
      resetKey={pathname}
      title="Something went wrong"
      description="The application hit an unexpected error. Try again, go to another page, or refresh if the problem continues."
    >
      {children}
    </AppErrorBoundary>
  );
}
